import React, { useEffect } from 'react';
import { MailIcon } from 'lucide-react';
export const ContactPage = () => {
  useEffect(() => {
    document.title = 'Contact | Race Capital';
  }, []);
  return <div className="w-full bg-white mt-20" data-id="element-230" data-mp="sq9btsc6en8w">
      <section className="w-full py-20 px-6 md:px-12 bg-white min-h-[80vh] flex items-center" data-id="element-231" data-mp="srkibzx0a93p">
        <div className="max-w-7xl mx-auto w-full" data-id="element-232" data-mp="xoaz6pgmx8q6">
          <h1 className="text-[clamp(2.5rem,5vw,4rem)] font-semibold text-[#070707] tracking-tight leading-[1.15] text-center mb-20" data-id="element-233" data-mp="z3a57gt4hhi">
            Contact Us
          </h1>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-16 mb-20" data-id="element-234" data-mp="50ykt2kmo77y">
            {/* Get in touch */}
            <div className="text-center" data-id="element-235" data-mp="a1upvjgptzey">
              <h2 className="text-2xl font-semibold text-[#070707] mb-8" data-id="element-236" data-mp="eze4ikhbse7f">
                Get in touch
              </h2>
              <div className="flex justify-center space-x-6" data-id="element-237" data-mp="1le57qutx8b4m">
                <a href="https://medium.com/racecapital" target="_blank" rel="noopener noreferrer" className="text-red-600 hover:text-red-700 transition-colors" data-id="element-238" data-mp="1qdrnbax823gl">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="currentColor" data-id="element-239" data-mp="mzl9qlmb4d7o">
                    <path d="M13.54 12a6.8 6.8 0 01-6.77 6.82A6.8 6.8 0 010 12a6.8 6.8 0 016.77-6.82A6.8 6.8 0 0113.54 12zM20.96 12c0 3.54-1.51 6.42-3.38 6.42-1.87 0-3.39-2.88-3.39-6.42s1.52-6.42 3.39-6.42 3.38 2.88 3.38 6.42M24 12c0 3.17-.53 5.75-1.19 5.75-.66 0-1.19-2.58-1.19-5.75s.53-5.75 1.19-5.75C23.47 6.25 24 8.83 24 12z" data-id="element-240" data-mp="81kfdw12u9fn"></path>
                  </svg>
                </a>
                <a href="https://www.linkedin.com/company/racecapital/posts/?feedView=all" target="_blank" rel="noopener noreferrer" className="text-red-600 hover:text-red-700 transition-colors" data-id="element-241" data-mp="3qdz1axbcay12">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-242" data-mp="36sp5v88vcnc1">
                    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" data-id="element-243" data-mp="3pl9qk2eezm4r"></path>
                    <rect x="2" y="9" width="4" height="12" data-id="element-244" data-mp="3ulfdx6dnimh1"></rect>
                    <circle cx="4" cy="4" r="2" data-id="element-245" data-mp="3groeiqtmwiz1"></circle>
                  </svg>
                </a>
                <a href="https://x.com/RaceCapital" target="_blank" rel="noopener noreferrer" className="text-red-600 hover:text-red-700 transition-colors" data-id="element-246" data-mp="3ks8a3pyk7ej2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="currentColor" data-id="element-247" data-mp="21v3igf3uqqyk">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" data-id="element-248" data-mp="2bjli2t0eas0m"></path>
                  </svg>
                </a>
              </div>
            </div>

            {/* Companies */}
            <div className="text-center" data-id="element-249" data-mp="1dyfzujqk58la">
              <h2 className="text-2xl font-semibold text-[#070707] mb-8" data-id="element-250" data-mp="1dzio0jwhwwxi">
                Companies
              </h2>
              <a href="mailto:deals@race.capital" className="text-lg text-gray-700 hover:text-red-600 transition-colors" data-id="element-251" data-mp="1nvluu32aljqs">
                deals@race.capital
              </a>
            </div>

            {/* Media */}
            <div className="text-center" data-id="element-252" data-mp="2zcli2k9s98dy">
              <h2 className="text-2xl font-semibold text-[#070707] mb-8" data-id="element-253" data-mp="18u5gmsux5kcr">
                Media
              </h2>
              <a href="mailto:media@race.capital" className="text-lg text-gray-700 hover:text-red-600 transition-colors" data-id="element-254" data-mp="1dti1j828chcp">
                media@race.capital
              </a>
            </div>
          </div>

          {/* Office */}
          <div className="text-center" data-id="element-255" data-mp="1rsrjod9zxljb">
            <h2 className="text-2xl font-semibold text-[#070707] mb-8" data-id="element-256" data-mp="1rrq3xvi1cav9">
              Office
            </h2>
            <div className="text-lg text-gray-700 space-y-2" data-id="element-257" data-mp="1wp85v1xmxptr">
              <p data-id="element-258" data-mp="21j41vyuc92ma">Silicon Valley,</p>
              <p data-id="element-259" data-mp="21k5p11ompfkd">437 Lytton Ave,</p>
              <p data-id="element-260" data-mp="25jeehucmyra4">Palo Alto, CA 94301</p>
            </div>
          </div>
        </div>
      </section>
    </div>;
};